import { LazyQueryHookOptions, useLazyQuery } from '@apollo/client'
import B2C_GET_ORDER_PRICE from '@graphql/queries/getOrderPrice.query'
import { B2CGetOrderPriceQuery, B2CGetOrderPriceQueryVariables } from 'parkdepot-shared/gql/graphql'

const useLazyGetOrderPrice = (opts?: LazyQueryHookOptions<B2CGetOrderPriceQuery, B2CGetOrderPriceQueryVariables>) => {
    return useLazyQuery(B2C_GET_ORDER_PRICE, opts)
}

export default useLazyGetOrderPrice
